import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupervisionComponent } from './supervision.component';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import {ChartModule} from 'primeng/chart';
import { VolumetrieTraiteesComponent } from './volumetrie-traitees/volumetrie-traitees.component';
import { InvisibleComponent } from './invisible/invisible.component';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import { ButtonModule, ToastModule } from 'primeng';


@NgModule({
  declarations: [SupervisionComponent, VolumetrieTraiteesComponent, InvisibleComponent],
  imports: [
    CommonModule,
    PanelModule,
    TableModule,
    CardModule,
    ChartModule,
    DynamicDialogModule,
    ToastModule,
    ButtonModule
  ]
})
export class SupervisionModule { }
